import { useApi } from '@hooks/useApi';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { queryKeys } from '@utils/consts';
import { BenchUser } from '@root/globalTypes';
import { isError } from '@utils/apiHelpers';
import { UpdateBenchUserData } from '@services/types';

type UpdateBenchUserParams = {
  callback: (data: BenchUser) => void;
};

export function useUpdate({ callback }: UpdateBenchUserParams) {
  const { query } = useApi();
  const queryClient = useQueryClient();
  const [apiError, setApiError] = useState<string>('');

  const { mutate, isPending } = useMutation({
    mutationFn: ({ id, ...data }: UpdateBenchUserData & { id: string }): Promise<BenchUser> => {
      return query({
        path: `v1/staff/bench_users/${id}`,
        data,
        opt: {
          method: 'PUT',
        },
      });
    },
    onSettled: (data) => {
      if (!data) return;
      if (isError(data)) {
        setApiError(data.message);
      } else {
        callback(data);
      }
    },
    onSuccess: async () => {
      await queryClient.refetchQueries({ queryKey: queryKeys.benchUsers });
    },
  });

  return {
    mutate,
    isPending,
    error: apiError,
  };
}
